import { FC, useEffect, useState } from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Select,
  Spinner
} from '@chakra-ui/react';
import { GoDeviceCameraVideo } from 'react-icons/go';
import { Box, HStack, Stack } from '@chakra-ui/layout';
import CrucibleScene from 'helpers/nft/crucibleScene/crucibleScene';

type Props = {
  isLoading: boolean;
  scene: CrucibleScene;
  dataError: boolean;
  dataLoading: boolean;
};

const BottomBar: FC<Props> = ({ isLoading, scene, dataError, dataLoading }) => {
  const [value, setValue] = useState('custom');

  useEffect(() => {
    scene.selectCamera(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    setValue('custom');
    scene.ee.on('camera', (e) => {
      if (e.type === 'custom') {
        setValue('custom');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scene]);

  return (
    <Box bottom={0} m={4} left={0} right={0} position='absolute'>
      <Stack
        spacing={4}
        justifyContent='space-between'
        direction={['column', null, 'row']}
      >
        <Box>
          {(dataError || dataLoading) && (
            <Alert status={dataError ? 'error' : 'info'} borderRadius='md'>
              {dataError ? <AlertIcon /> : <Spinner size='sm' mr={2} />}
              <AlertDescription textAlign='left'>
                {dataError
                  ? 'Error loading data. Model may be inaccurate.'
                  : 'Loading Crucible data'}
              </AlertDescription>
            </Alert>
          )}
        </Box>
        <Box
          borderRadius='md'
          bg='whiteAlpha.100'
          backdropFilter='blur(20px)'
          px={3}
          py={2}
        >
          <HStack spacing={4}>
            <GoDeviceCameraVideo />
            <Select
              size='sm'
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
              }}
              disabled={isLoading}
            >
              <option value='custom'>Custom</option>
              <option value='initial'>Initial</option>
              <option value='idText'>Lid</option>
              <option value='centralPiece'>Central Piece</option>
              <option value='topShell'>Top Shell</option>
              <option value='bottomShell'>Bottom Shell</option>
              <option value='rewardPrograms'>Reward Programs</option>
            </Select>
          </HStack>
        </Box>
      </Stack>
    </Box>
  );
};

export default BottomBar;
